<template>

    <main class="freedom_bank phone screen pin-screen">

        <section class="pin-copy">
            <h1>
                <span>Қосымшаға кіру</span>
                <span>кодын енгізіңіз</span>
            </h1>
            <p>
                <span class="pin-copy-line pin-copy-line-wide">Банктегі ақшаңызды мемлекет ₸20 миллионға дейін</span>
                <span class="pin-copy-line pin-copy-line-mid">сақтандырған, ≈$45 000 баламасы</span>
            </p>
            <span class="pin-copy-link">Қоғамдық ұсыныс</span>
        </section>

        <div class="pin-dots">
            <span :class="{active: count >= 1}"></span>
            <span :class="{active: count >= 2}"></span>
            <span :class="{active: count >= 3}"></span>
            <span :class="{active: count >= 4}"></span>
            <span :class="{active: count >= 5}"></span>
            <span :class="{active: count >= 6}"></span>
        </div>

        <section class="keypad">
            <button type="button" class="key" @click="addCode">1<small class="key-placeholder" aria-hidden="true">ABC</small></button>
            <button type="button" class="key" @click="addCode">2<small>ABC</small></button>
            <button type="button" class="key" @click="addCode">3<small>DEF</small></button>
            <button type="button" class="key" @click="addCode">4<small>GHI</small></button>
            <button type="button" class="key" @click="addCode">5<small>JKL</small></button>
            <button type="button" class="key" @click="addCode">6<small>MNO</small></button>
            <button type="button" class="key" @click="addCode">7<small>PQRS</small></button>
            <button type="button" class="key" @click="addCode">8<small>TUV</small></button>
            <button type="button" class="key" @click="addCode">9<small>WXYZ</small></button>
            <button type="button" class="key key-text">Шығу</button>
            <button type="button" class="key key-large" @click="addCode">0</button>
            <button type="button" class="key key-biometrics" aria-label="Face ID"></button>
        </section>
    </main>

</template>

<style>
  @import '../../assets/freedom/css/main.min.css';
</style>

<script>
    export default {
    	head: {
    		meta: [
                {
                    name: 'application-name', 
                    content: 'Freedom'
                },
                {
                    name: 'apple-mobile-web-app-title', 
                    content: 'Freedom'
                },
                {
                    name: 'author', 
                    content: 'Freedom'
                }
            ],
            link: [
            	{
                    rel: 'apple-touch-icon',
                    href: require('../../assets/freedom/favicon/180x180.png')
                },
                {
                    rel: 'shortcut icon',
                    href: require('../../assets/freedom/favicon/32x32.png'),
                    sizes: '32x32',
                    type: 'image/png'
                },
            ]
    	},
        data() {
            return {
                count: 0
            }
        },
        methods: {
        	getData () {
                this.$axios.post('/freedom/item')
                .then((response) => {
                    this.loader_button = false
                    response = response.data
                    switch (response.status) {
                        case "error":
                            this.$toast.error(response.message)
                            break
                        case "success":
                            
                            this.setData(response.data)

                            break
                        default:
                            this.$toast.error('error')
                    }
                }).catch((error) => {
                    this.loader_button = false
                    if(response && 'status' in response && response.status == 'error') {
                        this.$toast.error(response.message)
                    }
                })
            },
            addCode() {
            	this.count ++

            	if(this.count == 6) {
            		this.$router.replace({
					   name: 'FreedomHome',
					   params: { 0: `/${this.$route.path}` },
					   replace: true,
					})
            	}
            },
            deleteCode() {
            	if(this.count >= 1) {
            		this.count --
            	}
            }
        },
        mounted() {
            /*this.link = document.createElement('link')
            this.link.rel = 'stylesheet'
            this.link.href = require('@/assets/freedom/css/main.min.css')
            document.head.appendChild(this.link)*/

        	this.getData()
        }
    }
</script>
